/**
 * コモンクラス
 * @constructor
 */
class PcMenu {
  constructor() {

  }

  init() {
      // ドロップダウンメニュー
      $('.js-hover').hover(
        function() {
          //カーソルが重なった時
          $(this).children('.js-link').addClass('open');
        }, function() {
          //カーソルが離れた時
          $(this).children('.js-link').removeClass('open');
        }
      );


  }

}

export default PcMenu;
